var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlockUserOptionDesktop(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "23px",
    viewBox: "0 0 23 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "colour/dark-grey copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.5013231,3.60375134 C19.5005688,3.60299705 19.500066,3.60199133 19.4993117,3.60098561 C19.4980546,3.59972846 19.496546,3.59872273 19.4952889,3.59746558 C18.374682,2.38707983 16.9752434,1.40826144 15.3520355,0.775662659 C14.9185766,0.606198596 14.4697808,0.462380431 14.0184706,0.348231048 C13.1080561,0.117166547 12.1745104,0 11.2437304,0 C6.09753769,0 1.61812742,3.48834481 0.350436212,8.48275746 C-0.388756995,11.3953267 0.0499818303,14.4210397 1.58594486,17.0024752 C3.12215931,19.5841621 5.5720568,21.4128151 8.48457861,22.151769 C9.39524453,22.3828335 10.3290417,22.5 11.2600731,22.5 C14.8323374,22.5 18.2255862,20.7749363 20.3373154,17.8852472 C21.1856276,16.7241418 21.7970963,15.4227382 22.1538702,14.0164882 C23.1178384,10.2178784 22.0158371,6.32422783 19.5013231,3.60375134 Z M1.56859645,8.79226824 C2.69473467,4.35577955 6.67330383,1.25740323 11.243479,1.25740323 C12.0699171,1.25740323 12.8996238,1.3614954 13.7097192,1.56716543 C14.1109955,1.66849186 14.5092547,1.79621849 14.8944397,1.94682527 C16.1284398,2.42806298 17.215607,3.13508515 18.1280329,4.00251989 L3.41557376,17.4465012 C3.14529053,17.1030473 2.89336142,16.7417419 2.6663235,16.3598192 C1.30183318,14.0667743 0.91212248,11.3792352 1.56859645,8.79226824 Z M20.9354585,13.7074803 C20.6181585,14.9568378 20.0753292,16.1129146 19.3223076,17.1437791 C17.4466677,19.7106316 14.4328211,21.2430996 11.2603245,21.2430996 C10.4333836,21.2430996 9.6036769,21.138756 8.79408434,20.9333374 C7.05346033,20.4918257 5.50040032,19.6103109 4.25382892,18.3835822 L18.9831336,4.92426359 C20.9271614,7.30757196 21.7380111,10.5439836 20.9354585,13.7074803 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RHP-Search--Desktop-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profile-5-Dropdown",
    transform: "translate(-762.000000, -270.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dropdown-menu",
    transform: "translate(746.000000, 221.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Interaction-field",
    transform: "translate(16.000000, 49.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/dark-grey-copy"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/dark-grey",
    mask: "url(#mask-2)",
    fill: "#646464"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.500000, -1.500000)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 25.5,
    height: 25.5
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockUserOptionDesktop);
export default __webpack_public_path__ + "static/media/blockUserOptionDesktop.1c8b256b4fd87743948d57d2e565a5b9.svg";
export { ForwardRef as ReactComponent };